<template lang="pug">
div
  v-divider
  v-list-tile(@click="select" :to="{name:'ProcessList'}" ripple id="dropdown-example")
    v-btn(depressed block color="primary") {{ $tf("drawer.process.start") }}

    //- v-overflow-btn(:items="dropdown_font" :label='$tf("drawer.process.start")' target="#dropdown-example" depressed block color="primary")
//- div
//-   v-list-group(prepend-icon="settings" no-action)
//-     v-list-tile(slot="activator")
//-       v-list-tile-content
//-         v-list-tile-title {{ $tf("drawer.process.title") }}
//-     //- v-list-tile(@click="select" :to="{name:'ProcessList'}" ripple)
//-     //-   v-list-tile-content
//-     //-     v-list-tile-title {{ $tf("drawer.process.start") }}
//-     //-   v-list-tile-action
//-     //-     v-icon play_arrow
//-     //- v-list-tile(@click="select" :to="{name:'ProcessSearch'}" ripple)
//-     //-   v-list-tile-content
//-     //-     v-list-tile-title {{ $tf("drawer.process.search") }}
//-     //-   v-list-tile-action
//-     //-     v-icon search
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ProcessDrawer',

  data() {
    return {
      dropdown_font: ['Arial', 'Calibri', 'Courier', 'Verdana'],
    }
  },

  created() {
  },

  methods: {
    ...mapActions({
      toggleDrawer: 'tools/toggleDrawer',
      toggleProcessDeployDialog: 'process/toggleProcessDeployDialog',
    }),

    select() {
      if (!this.$vuetify.breakpoint.lgAndUp) {
        this.toggleDrawer()
      }
    },
  },
}
</script>

<style lang="stylus">
</style>



// WEBPACK FOOTER //
// src/components/process/ProcessDrawer.vue